var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatsIcon = function SvgChatsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chats"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5995 2.79688H4.39951C3.07391 2.79688 1.99951 3.87128 1.99951 5.19688V15.5969V16.2593C1.99951 17.6561 3.57871 18.4689 4.71551 17.6569L6.97311 16.0441C7.38031 15.7529 7.86831 15.5969 8.36831 15.5969H15.5995C16.9251 15.5969 17.9995 14.5225 17.9995 13.1969V5.19688C17.9995 3.87128 16.9251 2.79688 15.5995 2.79688Z",
    fill: "#8F979A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3993 8.40078H7.59932C7.15692 8.40078 6.79932 8.04238 6.79932 7.60078C6.79932 7.15918 7.15692 6.80078 7.59932 6.80078H12.3993C12.8417 6.80078 13.1993 7.15918 13.1993 7.60078C13.1993 8.04238 12.8417 8.40078 12.3993 8.40078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.7993 11.6H7.59932C7.15692 11.6 6.79932 11.2416 6.79932 10.8C6.79932 10.3584 7.15692 10 7.59932 10H10.7993C11.2417 10 11.5993 10.3584 11.5993 10.8C11.5993 11.2416 11.2417 11.6 10.7993 11.6Z",
    fill: "white"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chats-icon.68b5d15b6aea954388694125533d8983.svg";